import React from "react";
import { observer } from "mobx-react";
import { EditionDocumentationWorkflowStateCreateStore } from "../../store";
import { EditionDocumentationWorkflowStateCreateForm } from "./EditionDocumentationWorkflowStateCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type EditionDocumentationWorkflowStateCreateProps = {
  editionDocumentationWorkflowStateCreateStore: EditionDocumentationWorkflowStateCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const EditionDocumentationWorkflowStateCreate: React.FC<EditionDocumentationWorkflowStateCreateProps> =
  observer(
    ({
      editionDocumentationWorkflowStateCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay
            open={editionDocumentationWorkflowStateCreateStore.isSaving}
          />
          <EditionDocumentationWorkflowStateCreateForm
            editionDocumentationWorkflowStateCreateStore={
              editionDocumentationWorkflowStateCreateStore
            }
            name_esError={
              editionDocumentationWorkflowStateCreateStore.errors.name_es
                ?.message
            }
            onName_esChange={(value: string) => {
              editionDocumentationWorkflowStateCreateStore.setName_esValue(
                value
              );
            }}
            name_es={
              editionDocumentationWorkflowStateCreateStore.entityValues.name_es
            }
            name_enError={
              editionDocumentationWorkflowStateCreateStore.errors.name_en
                ?.message
            }
            onName_enChange={(value: string) => {
              editionDocumentationWorkflowStateCreateStore.setName_enValue(
                value
              );
            }}
            name_en={
              editionDocumentationWorkflowStateCreateStore.entityValues.name_en
            }
            name_ptError={
              editionDocumentationWorkflowStateCreateStore.errors.name_pt
                ?.message
            }
            onName_ptChange={(value: string) => {
              editionDocumentationWorkflowStateCreateStore.setName_ptValue(
                value
              );
            }}
            name_pt={
              editionDocumentationWorkflowStateCreateStore.entityValues.name_pt
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={editionDocumentationWorkflowStateCreateStore.isProcessing}
            onSave={() =>
              editionDocumentationWorkflowStateCreateStore.saveNewEditionDocumentationWorkflowState()
            }
            onCancel={() =>
              editionDocumentationWorkflowStateCreateStore.cancelNewEditionDocumentationWorkflowState()
            }
          />
          <ErrorDialog
            open={
              editionDocumentationWorkflowStateCreateStore.errorDialogOpened
            }
            title={editionDocumentationWorkflowStateCreateStore.errorTitle}
            description={
              editionDocumentationWorkflowStateCreateStore.errorDescription
            }
            onClose={() =>
              editionDocumentationWorkflowStateCreateStore.closeErrorDialog()
            }
          />
        </>
      );
    }
  );
